import React from 'react';
import ReactApexChart from 'react-apexcharts';
import getChartColorsArray from '../../components/Common/ChartsDynamicColor';

// Define interfaces
interface ChartData {
  name: string;
  data: number[];
}

interface StackedColumnChartProps {
  dataColors: string;
  periodData: ChartData[];
}

// Define the chart options type (aligned with ApexCharts options structure)
interface ChartOptions {
  chart: {
    stacked: boolean;
    toolbar: {
      show: boolean;
    };
    zoom: {
      enabled: boolean;
    };
  };
  plotOptions: {
    bar: {
      horizontal: boolean;
      columnWidth: string;
    };
  };
  dataLabels: {
    enabled: boolean;
  };
  xaxis: {
    show: boolean;
    categories: string[];
    labels: {
      show: boolean;
    };
  };
  colors: string[];
  legend: {
    position: 'bottom' | 'top' | 'right' | 'left' | undefined;
  };
  fill: {
    opacity: number;
  };
}

const StackedColumnChart: React.FC<StackedColumnChartProps> = ({ dataColors, periodData }) => {
  const stackedColumnChartColors: string[] = getChartColorsArray(dataColors);

  const options: ChartOptions = {
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '15%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      show: true,
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      labels: {
        show: true,
      },
    },
    colors: stackedColumnChartColors,
    legend: {
      position: 'bottom',
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={periodData}
        type="bar"
        height={359}
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export default StackedColumnChart;
